// Loader.js
import React from "react";
import logo from "../Images/Logo_04-removebg-preview (1).png";
import sglogo from "../Images/companylogo - Copy.png"



export default function Loader() {

    const loaderStyle = {
        height: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 9999,
        background: "white",
        flexDirection: "column",
        color: "#0A1733",
        textAlign: "center",
    };

    const logoStyle = {
        width: "20vw",        // responsive (20% of viewport width)
        maxWidth: "140px",    // won’t grow too big
        minWidth: "100px",    // won’t shrink too small
        animation: "bounce 2s infinite",
        objectFit: "contain",
        filter: "drop-shadow(0px 0px 10px rgba(0,0,0,0.4))",
    };

    const titleStyle = {
        marginTop: "20px",
        fontSize: "28px",
        fontWeight: "bold",
        animation: "pulse 2s infinite",
        textShadow: "0 0 8px rgba(255,255,255,0.6)",
    };

    const subTextStyle = {
        marginTop: "10px",
        fontSize: "16px",
        opacity: 0.8,
        animation: "fadeIn 3s ease-in-out infinite alternate",
    };

    return (
        <>
            <style>
                {`
          @keyframes gradientShift {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }

          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
            40% { transform: translateY(-20px); }
            60% { transform: translateY(-10px); }
          }

          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.6; }
            100% { opacity: 1; }
          }

          @keyframes fadeIn {
            from { opacity: 0.5; }
            to { opacity: 1; }
          }
        `}
            </style>

            <div style={loaderStyle}>
                {/* <img src={logo} alt="Company Logo" style={logoStyle} /> */}
                <img src={sglogo} alt="Company Logo" style={logoStyle} />

                {/* <p style={subTextStyle}>Loading, please wait...</p> */}
            </div>
        </>
    );
}

